import { http } from '@/http/axios';
import type { TrustpilotCollectorPayload } from '@/types/trustpilot';

export interface TrustpilotReviewRequest {
  id: number;
  cycleNumber: number;
}

export const trustpilotService = {
  /** Le back répond 204 quand l'utilisateur n'a aucune demande active. */
  getReviewRequest: async (): Promise<TrustpilotReviewRequest | null> => {
    const response = await http.get<TrustpilotReviewRequest>('/trustpilot/review-request');
    return response.status === 204 ? null : response.data;
  },

  markDisplayed: async (): Promise<void> => {
    await http.post('/trustpilot/review-request/displayed');
  },

  /** Le refus vit côté serveur : il remet le compteur de conversions à zéro, tous navigateurs confondus. */
  dismiss: async (): Promise<void> => {
    await http.post('/trustpilot/review-request/dismissed');
  },

  getPayload: async (): Promise<TrustpilotCollectorPayload> => {
    const response = await http.get<TrustpilotCollectorPayload>(
      '/trustpilot/review-request/payload',
    );
    return response.data;
  },
};
